import { provideSoftAppsModule, provideSoftAppsRoutes, withSoftAppsModuleTranslation } from '@softapps/core';
import * as deMain from '../i18n/de.json';
import { eslConfigRoutes } from './esl-config.router';

export function provideEslConfigModule() {
  return [
    ...provideSoftAppsModule(
      {
        name: 'handel-esl-config',
        icon: 'fa-regular fa-paintbrush-pencil',
        title: 'ESL Varianten',
        route: '/esl-config',
        permission: 'ESL_CONFIG'
      },
      withSoftAppsModuleTranslation({
        de: deMain,
      })
    ),
    provideSoftAppsRoutes({
      app: eslConfigRoutes,
    }),
  ];
}
